export const events = [
  {
    num: '01',
    title: 'Royal Weddings',
    description:
      "From regal ceremonies to grand receptions, we design weddings that feel like fairy tales — every drape, bloom and light considered.",
    icon: (
      <svg width="34" height="34" viewBox="0 0 34 34">
        <path
          d="M17 3 C 10 3 6 9 6 14 C 6 20 11 24 17 30 C 23 24 28 20 28 14 C 28 9 24 3 17 3 Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.3"
        />
        <circle cx="17" cy="14" r="4" fill="none" stroke="currentColor" strokeWidth="1.1" />
      </svg>
    ),
  },
  {
    num: '02',
    title: 'Corporate Galas',
    description:
      'Elevate your brand with sophisticated award nights, conferences and product launches, produced with precision.',
    icon: (
      <svg width="34" height="34" viewBox="0 0 34 34">
        <rect x="6" y="12" width="22" height="16" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.2" />
        <path d="M11 12 V8 a6 6 0 0 1 12 0 v4" fill="none" stroke="currentColor" strokeWidth="1.2" />
      </svg>
    ),
  },
  {
    num: '03',
    title: 'Milestone Birthdays',
    description:
      'Turn birthdays into royal courts with custom themes, larger-than-life décor and unforgettable entrances.',
    icon: (
      <svg width="34" height="34" viewBox="0 0 34 34">
        <circle cx="17" cy="17" r="12" fill="none" stroke="currentColor" strokeWidth="1.2" />
        <path d="M17 5 v4 M17 25 v4 M5 17 h4 M25 17 h4" stroke="currentColor" strokeWidth="1.1" />
        <text x="17" y="21" textAnchor="middle" fontFamily="Cormorant Garamond, serif" fontSize="13" fill="currentColor">
          40
        </text>
      </svg>
    ),
  },
  {
    num: '04',
    title: 'Anniversary Affairs',
    description:
      "Celebrate love's journey with intimate, candlelit anniversary evenings tailored to your years together.",
    icon: (
      <svg width="34" height="34" viewBox="0 0 34 34">
        <path d="M17 5 C 10 12 8 18 17 29 C 26 18 24 12 17 5 Z" fill="none" stroke="currentColor" strokeWidth="1.2" />
        <path d="M17 12 v11 M12 17 h10" stroke="currentColor" strokeWidth="1" />
      </svg>
    ),
  },
  {
    num: '05',
    title: 'Private Soirées',
    description:
      'Exclusive, curated gatherings — from rooftop dinners to garden parties — for the moments that matter most.',
    icon: (
      <svg width="34" height="34" viewBox="0 0 34 34">
        <path d="M8 26 L17 8 L26 26 Z" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
        <path d="M12 20 h10" stroke="currentColor" strokeWidth="1" />
      </svg>
    ),
  },
  {
    num: '06',
    title: 'Destination Events',
    description:
      'We bring the full Zafwa Royale production — design, logistics and crew — to venues near and far.',
    icon: (
      <svg width="34" height="34" viewBox="0 0 34 34">
        <path d="M6 24 C 6 14 12 6 17 4 C 22 6 28 14 28 24" fill="none" stroke="currentColor" strokeWidth="1.2" />
        <path d="M4 24 h26" stroke="currentColor" strokeWidth="1.2" />
      </svg>
    ),
  },
]
